import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "../lib/site";

export const WhatsAppFloat = () => {
  return (
    <motion.a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-btn"
      aria-label="Chat with us on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 2, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
      <span className="relative flex items-center gap-2.5 bg-[#25D366] text-white rounded-full pl-4 pr-5 py-4 shadow-[0_8px_30px_rgba(37,211,102,0.35)]">
        <MessageCircle size={22} fill="currentColor" strokeWidth={0} />
        <span className="hidden sm:inline text-sm font-bold tracking-wide">
          Chat with us
        </span>
      </span>
    </motion.a>
  );
};
